/*
 * Copyright(c) 2021 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import * as moment from 'moment';
import * as _ from 'underscore';
import { Pipe, PipeTransform } from '@angular/core';

const invalidDate = new Date(NaN);
const defaultFormat = 'MMM/DD/YYYY hh:mm A';

@Pipe({
  name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {
  transform(input: any, format: string): any {
    if (_.isUndefined(input) || input === '') {
      return '';
    }

    if (!_.isNumber(input) && !_.isString(input) && !_.isDate(input)) {
      return invalidDate;
    }

    if (!_.isUndefined(format) && !_.isEmpty(format)) {
      return moment(input).format(format);
    } else {
      return moment(input).format(defaultFormat);
    }
  }
}
